import React from 'react'
import { DialogContent } from '@common/material'
import ChecklistDetails from '@modules/checklistDetails/ChecklistDetails'
import { ModalDialogContainer } from '@common/modal'

type ChecklistDetailsModalProps = {
  checklistId: number
  organisationId: number
  projectId?: number
}

const ChecklistDetailsModal: React.FC<ChecklistDetailsModalProps> = ({
  checklistId,
  organisationId,
  projectId,
}) => {
  return (
    <ModalDialogContainer
      PaperProps={{
        sx: {
          maxHeight: '99%',
          maxWidth: '90%',
        },
      }}
    >
      <DialogContent
        sx={{
          overflow: 'auto',
          height: '100vh',
          flexDirection: 'column',
          my: '20px',
          py: 0,
        }}
      >
        <ChecklistDetails
          checklistId={checklistId}
          isModal
          organisationId={organisationId}
          projectId={projectId}
        />
      </DialogContent>
    </ModalDialogContainer>
  )
}

export default ChecklistDetailsModal
